<template>
  <div
    v-if="!compareToUserId(ride.authorId) && !isRideLocked"
    class="ofer-importing-ride smale-one  ofer-import-ride-header">
    <h3>
      {{ t('wantToEditTrip') }}
    </h3>
    <b-btn
        class="import-btm"
        variant="warning"
        @click="addRideToUser(ride.id)"
      >
        {{ t('copyAndEdit') }}
    </b-btn>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { translationMixin } from "@/mixins/translationMixin";

// "Want to edit this trip? Copy and edit", for anyone who is not its author.
export default {
  name: 'RideCopyOffer',
  mixins: [translationMixin],
  props: {
    ride: { type: Object, required: true },
  },
  computed: {
    ...mapGetters(['compareToUserId', 'isRideLocked']),
  },
  methods: {
    ...mapActions(['addRideToUser']),
  },
};
</script>
